export default {
  /**
   * 顧客条件の標準フォーマット
   */
  get() {
    return {
      /**
       * 選択タイプ
       */
      type: 'all',
      /**
       * 選択ファイル
       */
      file: undefined,
      /**
       * 顧客グループID
       */
      customerGroupId: undefined,
      /**
       * 年代
       */
      ages: undefined,
      /**
       * 性別
       */
      sexes: undefined,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(customer) {
    if (customer.type === 'attribute') {
      return {
        ages: customer.ages,
        sexes: customer.sexes,
      }
    } else {
      return {
        customerGroupId: customer.customerGroupId,
      }
    }
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, customer) {
    if (customer.ages || customer.sexes) {
      applyTo.type = 'attribute'
      applyTo.ages = customer.ages
      applyTo.sexes = customer.sexes
    }
    applyTo.customerGroupId = customer.customerGroupId
  },
  summaryText(customer) {
    if (customer.ages || customer.sexes) {
      return '属性指定'
    } else if (customer.customerGroupId) {
      return '選択顧客'
    } else {
      return '全顧客'
    }
  },
}
